var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "frequency-buttons" },
    [
      _c(
        "mds-button",
        {
          attrs: { variation: "flat" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.translate("frequency.modal.cancel.button")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "mds-button",
        {
          attrs: { variation: "primary", disabled: _vm.disableSaveButton },
          on: {
            click: function ($event) {
              return _vm.$emit("save-schedule")
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.saveButtonName) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }